// @ts-nocheck
import { Card } from 'antd';
import Button from 'atoms/button/button';
import Heading from 'atoms/heading/heading';
import Icon from 'atoms/icons/icon';
import { ThetaIconPlus, ThetaLogoDark } from 'atoms/icons/navSvg';
import Label from 'atoms/label/label';
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import { loginRequest } from 'authConfig';
import { isLoggedOut } from 'models/subscriptions/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import React from 'react';
import { useCallback } from 'react';
import { useLayoutEffect } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SignInButton } from './authentication';
import './login.scss';

export const LoginPage = () => {
	const isLoggedOutUser: any = useSelector((state) => isLoggedOut(state));

	return (
		<Sheet isPage className="login-wrapper">
			<Stack isVertical>
				<StackItem align="center" isStretch isGrow>
					<Card className="login--card">
						<Stack isVertical position="center" gutter="medium" align="center">
							<StackItem className="login-logo p-0">
								<ThetaLogoDark height="200" width="200"></ThetaLogoDark>
							</StackItem>
							<StackItem className="login-title p-0">
								<Heading type="primary"> Welcome to Skulicity</Heading>
							</StackItem>
							{isLoggedOutUser ? (
								<>
									<StackItem className="login-sub-title p-0">
										<Heading type="secondary"> Sign in to continue to Skulicity </Heading>
									</StackItem>
									<StackItem className="btn-container w-100 p-0 mt-4">
										<SignInButton />
									</StackItem>
								</>
							) : (
								<StackItem className="p-0 w-100">
									<Stack isVertical>
										<StackItem>
											<Stack isVertical position="center" align="center" gutter="small">
												<StackItem className="btn-container w-100 p-0 mt-4">
													<SignInButton />
												</StackItem>
												<StackItem className="login-bottom-content p-0">
													<Label>
														<div className="d-block">
															New to Skulicity?{' '}
															<a
																href="mailto:help@skulicity.com"
																className="black underline"
															>
																Contact Support
															</a>
														</div>
													</Label>
												</StackItem>
											</Stack>
										</StackItem>
									</Stack>
								</StackItem>
							)}
						</Stack>
					</Card>
				</StackItem>
				<StackItem align="center">
					<div className="m-4 d-block">
						© 2025 Skulicity |{' '}
						<a href="https://www.skulicity.com/privacy-policy/" target="_blank" rel="noreferrer">
							Privacy Policy
						</a>
					</div>
				</StackItem>
			</Stack>
		</Sheet>
	);
};
